import React, { Fragment, useState } from "react";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

function CustomDateTimePicker({ selectedDate, setDate, error }) {
  return (
    <Fragment>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DateTimePicker
          value={selectedDate}
          disablePast
          onChange={setDate}
          label="Thời gian hạ bài"
          showTodayButton
          ampm={false}
          format="dd/MM/yyyy hh:mm a"
          minDate={new Date()}
          error={Boolean(error)}
        />
      </MuiPickersUtilsProvider>
      {error && <p style={{ color: "red" }}>{error}</p>}
    </Fragment>
  );
}

export default CustomDateTimePicker;
